import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { ALL_USERS } from '../../admin/get-all-users';
import { GET_USER_IN_2N } from '../get-user';
import { createUserIn2nAPI } from './api';

export function useCreateUserIn2n(selectedUser) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutateAsync, mutate, isLoading, isSuccess, isError } = useMutation(
    (user) => createUserIn2nAPI(user),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ALL_USERS, tenantId]);
        queryClient.invalidateQueries([GET_USER_IN_2N, tenantId, selectedUser?.email]);
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'updateUserPermissionsSuccess',
          },
        });
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'genericErrorMessage',
          },
        });
      },
    },
  );

  return {
    mutateAsync,
    mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
